/* ============
 * Members Page
 * ============
 *
 * This is the page for members.
 */
import Vue from 'vue';
import Moment from 'moment';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import nbLocale from '@fullcalendar/core/locales/nb';
import Tooltip from 'tooltip.js';
import addMember from '../create/create.vue';
import addBooking from '../../booking/create/create.vue';
import organizationMemberProductBusinesshourService from './../../../../services/organizationMemberProductBusinesshour';
import organizationMemberBookingService from './../../../../services/organizationMemberBooking';
import { mapGetters, mapMutations } from 'vuex';

import organizationMemberService from './../../../../services/organizationMember';

window.jQuery = require('jquery');

export default {
  components: {
    FullCalendar
  },

  data: () => ({
    calendarPlugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
    membersLoading: true,
    calendarLoading: true,
    addBooking: false,
    modalLoading: true,
    clients: [],
    events: [],
    header: {
      right: 'toggle_view today prev,next ',
    },

    current_tab: 'members',
    calendar_data_type: 'businesshours',
    min_time: '06:00',
    default_view: 'timeGridWeek',
    start_date: null,
    end_date: null
  }),

  computed: {
    ...mapGetters({
      account: 'account',
      organization_settings: 'organizationSettings',
      organization_members: 'allOrganizationMembers',
      organization_member_product_businesshours: 'allOrganizationMemberProductBusinessHours',
      organization_member_bookings: 'allOrganizationMemberBookings',
    }),

    customButtons() {
      var $this = this;
      return {
        toggle_view: {
          text: (this.default_view == 'timeGridWeek') ? 'Vis dag' : 'Vis uke',
          click: function() {
            $this.default_view = $this.default_view == 'timeGridWeek' ? 'timeGridDay' : 'timeGridWeek';
            $this.$refs.fullCalendar.getApi().changeView($this.default_view);
          }
        },
      }
    },

    timeslot_gap() {
      var timeslot_gap = '00:15';
      if (this.default_view == 'timeGridDay') {
        timeslot_gap = '00:10';
      }
      /*if (this.organization_settings && this.organization_settings.timeslot_gap) {
        timeslot_gap = '00:' + this.organization_settings.timeslot_gap;
      }*/

      return timeslot_gap;
    },

    productMembers() {
      var organization = {
        id: '',
        user: {
          full_name: this.account.firstName + ' ' + this.account.lastName + ' (Organization)'
        }
      };
      var product_members = [organization];
      return product_members;

      if (this.newBookingForm.product_id) {
        var $this = this;
        for (var om of this.organization_members){
          if (om.organization_member_products.findIndex(x => x.product_id == $this.newBookingForm.product_id) > -1) {
            product_members.push(om);
          }
        };
      }


      return product_members;
    },

    memberProducts() {
      var member_products = [];
      return member_products;

      for (var om of this.organization_members){
        om.organization_member_products.forEach(function(omp) {
          if (member_products.findIndex(x => x.product_id == omp.product_id) == -1) {
            member_products.push(omp);
          }
        });
      };

      return member_products;
    },
  },

  watch: {
    current_tab: function (tab) {
      switch (tab) {
        case 'members':
          this.membersLoading = true;
          this.getMembers();
          window.history.pushState('', '', '/#/members/');
          this.$route.query.tab = this.$route.query.data = '';
          break;

        case 'calendar_schedule':
          this.calendar_data_type = this.$route.query.data || 'businesshours';
          this.calendarLoading = true;
          this.getSchedule();
          break;
      }
    },

    calendar_data_type: function (type) {
      this.calendarLoading = true;
      this.getSchedule();
    },

    '$route': function(route){
      if (route.query.tab == 'calendar' && route.query.data == 'bookings')
      {
        this.current_tab = 'calendar_schedule';
        this.calendar_data_type = 'bookings';
      }
    }
  },

  created() {
    this.start_date = Moment().day('monday').format('YYYY-MM-DD');
    this.end_date = Moment( Moment().day('monday').toDate()).add(6, 'days').format('YYYY-MM-DD');

    if (this.mobilecheck()) {
      this.default_view = 'timeGridDay';
    }
    if (this.$route.query.tab == 'calendar' && this.$route.query.data == 'bookings') {
      this.current_tab = 'calendar_schedule';
      this.calendar_data_type = 'bookings';
    }
  },

  mounted() {
    this.getMembers();
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    updateBookingEvents() {
      if (this.current_tab == 'calendar_schedule' && this.calendar_data_type == 'bookings') {
        let calendarApi = this.$refs.fullCalendar.getApi()
       // console.log(calendarApi.state.dateProfile.activeRange);
        let start_date =  Moment(calendarApi.state.dateProfile.activeRange.start).format('YYYY-MM-DD');
        let end_date =  Moment(calendarApi.state.dateProfile.activeRange.end).format('YYYY-MM-DD');

        if (start_date != this.start_date || end_date != this.end_date) {
          this.start_date = start_date;
          this.end_date = end_date;
         // this.calendarLoading =true;
           this.getSchedule();
        }
      }
    },

    mobilecheck() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },

    handleEventClick(e) {
      if (this.current_tab == 'calendar_schedule' && this.calendar_data_type == 'bookings') {

        var $this = this;
        console.log(e);
        var event = {
          id: e.event.id,
          product_id: e.event.extendedProps.product_id,
          member_id: e.event.extendedProps.member_id,
          client_id: e.event.extendedProps.client_id,
          date: e.event.extendedProps.data_date,
          start_time: e.event.extendedProps.start_time,
          end_time: e.event.extendedProps.end_time,
          order_id: e.event.extendedProps.order_id,
          order_number:  e.event.extendedProps.order_number,
          order_status:  e.event.extendedProps.order_status,


        };
        this.setModalProps({
          action: 'EDIT',
          date: e.event.start,
          event: event,
          onUpdate: function(event){
            var index = $this.events.findIndex(x => x.id == event.id);
            if (index > -1) {
              for (var key in event) {
                $this.events[index][key] = event[key];
              }
            }
          }
        });
        this.setModalContent(() => addBooking);
        this.setModalCloseOnClick(false);
        this.setModalShowClose(true);
        this.setModalCloseOnPressEscape(false);
        this.toggleModal(true);
        window.jQuery('.tooltip').css('visibility', 'hidden');
      }
    },

    handleSlotClick(e) {
      if (this.current_tab == 'calendar_schedule' && this.calendar_data_type == 'bookings') {
        var $this = this;
        this.setModalProps({
          date: e.date,
          action: 'ADD',
          onStore: function(event){
            $this.events.push(event);
          }
        });
        this.setModalContent(() => addBooking);
        this.setModalCloseOnClick(false);
        this.setModalShowClose(true);
        this.setModalCloseOnPressEscape(false);
        this.toggleModal(true);
      }
    },

    resetForm(form) {
      for (var key in this[form]) {
        this[form][key] = '';
      }
    },

    selectAllow(e) {
      if (Moment(e.end).diff(e.start, 'minutes') > 30) {
          return false;
      }
      return true;
    },

    showToolTip(info) {
      var time = Moment(info.event.start).format('H:mm') + ' - ' + Moment(info.event.end).format('H:mm');
      var template = '';
      if (this.calendar_data_type == 'businesshours') {
        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>'+time+'</div>';
      } else if(this.calendar_data_type == 'bookings') {
        var product = 'Product: ' + info.event.extendedProps.productName;
        var member = 'Practitioner: ' + info.event.extendedProps.memberName;
        var status = 'Status: ' + info.event.extendedProps.status;
        template = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div>'+time+'<div><small>'+product+'</small></div><div><small>'+member+'</small></div><div><small>'+status+'</small></div></div>';
      }
      var tooltip = new Tooltip(info.el, {
        title: info.event.title,
        placement: 'top',
        trigger: 'hover',
        container: 'body',
        html: true,
        template: template
      });
    },

    resetFields() {
      this.$refs['newMemberForm'].resetFields();
      this.member_firstname = this.member_lastname = this.member_email = '';
    },

    addMember() {
      this.setModalContent(() => addMember);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    getMembers() {
      organizationMemberService.all().then(() => {
        this.membersLoading = false;
      });
    },

    getSchedule() {
      var events = [];
      switch (this.calendar_data_type){
        case 'businesshours':
          organizationMemberProductBusinesshourService.all().then(() => {
            this.calendarLoading = false;
            this.organization_member_product_businesshours.forEach(s => {
              events.push({
                title: s.organizationMemberProduct.organization_member.user.full_name,
                daysOfWeek: Moment().locale('en').day(s.day).format('d'),
                startTime: s.startTime,
                endTime: s.endTime,
                backgroundColor: s.organizationMemberProduct.organization_member.color,
                borderColor: s.organizationMemberProduct.organization_member.color,
              });

            });
            this.events = events;
          });
          break;
        case 'bookings':

          organizationMemberBookingService.all(this.start_date, this.end_date).then(() => {
            this.calendarLoading = false;
            this.organization_member_bookings.forEach(s => {

              events.push({
                id: s.id,
                product_id: s.order.order_products.length > 0 ? s.order.order_products[0].product_id : '',
                member_id: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member_id : '',
                client_id: s.order.client_id,
                data_date: s.date,
                start_time: s.startTime,
                end_time: s.endTime,
                status: s.status,
                order_id: s.order.id,
                order_number: s.order.number,
                order_status: s.order.order_status.name,
                title: s.order.client.name || s.order.client.client_contact.email,
                productName: s.order.order_products.length > 0 ? s.order.order_products[0].name : '',
                memberName: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member.user.full_name : s.order.organization.name,
                start: s.date + ' ' + s.startTime,
                end: s.date + ' ' + s.endTime,
                backgroundColor: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member.color : '#777777',
                borderColor: s.organizationMemberProduct ? s.organizationMemberProduct.organization_member.color : '#777777',
              });
            });
            this.events = events;
          });

          break;
      }
    },

    navigateTab(tab) {
      var new_tab = tab.label.toLowerCase();

      if (new_tab != this.current_tab) {
        switch (new_tab){
          case 'members':
            this.membersLoading = true;
            this.getMembers();
            break;

          case 'schedule':
            break;
        }
      }

    },

    acceptStatus(member) {
      var status = '';

      if (member.isAccepted == 1) {
        status = 'ACTIVE';
      } else {
        status = 'PENDING';
      }
      return status;
    },


  	formatDate(date) {
      if (!date) return '';
  		return Moment(date).format('MMM DD, YYYY');
  	}
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/members/index/index.js